import '../scss/app.scss';
import Alpine from 'alpinejs';
import marquee from './marquee.js';
import mobileFlickity from './mobile-flickity';
import headerScroll from './header-scroll';
import collapse from '@alpinejs/collapse';
import blogTagScroll from './blog-tag-scroll';
import blogSearch from './blog-search';
import amazonBuyButton from './amazon-buy-button';

Alpine.plugin(collapse);

window.Alpine = Alpine;

Alpine.data('marquee', marquee);
Alpine.data('mobileFlickity', mobileFlickity);
Alpine.data('headerScroll', headerScroll);
Alpine.data('blogTagScroll', blogTagScroll);
Alpine.data('blogSearch', blogSearch);
Alpine.data('amazonBuyButton', amazonBuyButton);


Alpine.start();
